export const UserRole = {
    admin: 'ADMINSIMTARU',
    superAdmin: 'SUPERADMIN',
    superVisor: 'SUPERVISOR',
    manager: 'MANAGER',
    dataEntry: 'DATAENTRY'
}
